import React from 'react';
import { isAuthorized } from '../AuthorizedAction.js';
import Empty from '../Empty.jsx';
import { initiativeSurveyContent } from '../EmptyStates.jsx';
import SelectSurveyModal from './SelectSurveyModal/index.jsx';

const EmptyChangeInsightsView = ({
  showModal,
  handleShow,
  handleClose,
  surveyTemplates,
  organization,
  initiative,
  permissions,
}) => {
  return (
    <React.Fragment>
      <Empty
        content={initiativeSurveyContent}
        action={
          initiative &&
          initiative.project.manageProjectEntities &&
          permissions &&
          isAuthorized('update', `${initiative.type}Initiative`, permissions)
            ? handleShow
            : null
        }
        addBtn
        className="component-bg-white px-0 py-0 h-100"
      ></Empty>
      <SelectSurveyModal
        organization={organization}
        initiative={initiative}
        surveyTemplates={surveyTemplates}
        showModal={showModal}
        handleClose={handleClose}
      />
    </React.Fragment>
  );
};

export default EmptyChangeInsightsView;
